module.exports = __webpack_public_path__ + "img/the-stack.9bcba0ba.png";